import { useContext } from 'react'
import { TenantSettingsContext, UserContext } from '../../App'

// Org branding + "generated by" identity for the PDF header/footer chrome,
// in one place so every Print handler doesn't repeat the context plumbing.
export const usePrintChrome = () => {
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  const { user } = useContext(UserContext)
  return {
    orgName: orgSettings?.orgName || '',
    logo: orgSettings?.logo || null,
    generatedBy: [user?.firstName, user?.lastName].filter(Boolean).join(' '),
  }
}

export default usePrintChrome
